module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/bump-icon-alt-d5e271841dcb0fc0f2f629bbd706f982.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/bump-icon-alt.svg
// module id = 4wzY
// module chunks = 24